// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1HGZ2","image":"Header_image__33FX9","name":"Header_name__17TkI","info":"Header_info__3LFTe","infoRow":"Header_infoRow__16dP5"};